/**
 * Returns color for content worfklowStep
 *
 * @param worflowStep - content workflowStep
 *
 * @returns {string} - color for content worfklowStep
 */
export function getWorkflowStepColor(worflowStep: string): string {
  switch (worflowStep) {
    case 'published':
      return '#00a85b';
    case 'review':
      return '#ffda00';
    case 'draft':
      return '#f02222';
    case 'archived':
      return '#4c4d52';
    default:
      return '#005b7f';
  }
}
